// src/components/ContactPage.js
import React from 'react';
import './ContactPage.css';

function ContactPage() {
  return (
    <div className="ContactPageContainer">
      <div className="CenterWrapper">
        {/* The image in the middle of the page */}
        <div className="ImageContainer">
          <img
            src="https://res.cloudinary.com/dgtjqqufz/image/upload/v1740556030/econoverse-images/sgywc8cprcofyrovrk19.png"
            alt="Center Visual"
            className="CenterImage"
            onError={(e) => {
              e.currentTarget.src = '/images/default_image.png';
            }}
          />

          {/* The text overlaid on top of the image */}
          <div className="OverlayText">
            {/* The big title at the top */}
            <h1 className="BigTitle">Contact Us</h1>

            {/* Big line 1: Email icon + "Email: econoverse.net@gmail.com" */}
            <div className="LineContainer">
              <img
                src="/images/email_icon.png"  // or your email icon path
                alt="Email Icon"
                className="ContactIcon"
                onError={(e) => {
                  // Fallback if email icon fails
                  e.currentTarget.src = '/images/default_image.png';
                }}
              />
              <h1 className="CustomText">Email: econoverse.net@gmail.com</h1>
            </div>

            {/* Big line 2: Instagram icon + "Instagram: instagram.com/_EconoVerse_" */}
            <div className="LineContainer">
              <img
                src="/images/instagram_icon.png"  // or your instagram icon path
                alt="Instagram Icon"
                className="ContactIcon"
                onError={(e) => {
                  // Fallback if instagram icon fails
                  e.currentTarget.src = '/images/default_image.png';
                }}
              />
              <h1 className="CustomText">Instagram: instagram.com/_EconoVerse_</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
